// mutations modify the state are strictly synchronous
// and do not return values

export default {

}
